import React, { Component } from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';

class ProductsListView extends Component {
    render() {
        const columns = [{
            title: 'Número Parte',
            dataIndex: 'part_num',
            key: 'part_num',
        }, {
            title: 'Descripción',
            dataIndex: 'description_en',
            key: 'description_en',
        }, {
            title: 'Cantidad',
            dataIndex: 'dimension',
            key: 'dimension',
            render: (dimension, row) => row.quantity + ' ' + dimension
        }, {
            title: 'Peso',
            dataIndex: 'kg_per_pc',
            key: 'kg_per_pc',
            render: (kgs) => kgs.toFixed(4) + ' kgs'
        }, {
            title: 'Precio',
            dataIndex: 'price',
            key: 'price',
            render: (price) => '€ ' + price
        }];
        return (
            <div>
                <h2>Lista de productos</h2>
                <Table dataSource={this.props.products} columns={columns} />
            </div>
        );
    }
}

export default ProductsListView;



// WEBPACK FOOTER //
// ./src/components/views/ProductsListView.jsx